module.exports = __webpack_public_path__ + "static/img/banner.7a003ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner.jpg
// module id = 1HFN
// module chunks = 1